import React from "react";
import "./Contact.css";

const contactInfo = {
  title: "Fale com o Kito",
  subtitle:
    "Se você representa uma empresa, editora, escola ou quer conversar sobre parcerias, investimento e novos projetos, vamos falar.",
  email: "contato@kito.app.br",
  whatsappDisplay: "(11) 98759-9856",
  whatsappHref: "https://wa.me/5511987599856",
};

export default function Contact() {
  return (
    <main className="contact-page">
      <section className="contact-hero">
        <span className="contact-eyebrow">Contato</span>
        <h1>{contactInfo.title}</h1>
        <p>{contactInfo.subtitle}</p>
      </section>

      <section className="contact-grid">
        <article className="contact-card">
          <h2>E-mail</h2>
          <p>
            Ideal para propostas comerciais, editoriais, investidores e conversas
            institucionais.
          </p>
          <a className="contact-primary" href={`mailto:${contactInfo.email}`}>
            {contactInfo.email}
          </a>
        </article>

        <article className="contact-card contact-card-accent">
          <h2>WhatsApp</h2>
          <p>
            Melhor caminho para um primeiro contato mais rapido e direto.
          </p>
          <a
            className="contact-primary"
            href={contactInfo.whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            Chamar no WhatsApp
          </a>
          <span className="contact-meta">{contactInfo.whatsappDisplay}</span>
        </article>
      </section>

      <section className="contact-note">
        <div className="contact-note-card">
          <h3>Quem pode entrar em contato</h3>
          <p>
            Clientes, investidores, editoras, parceiros de tecnologia, redes de
            cuidado, escolas e qualquer pessoa interessada no ecossistema Kito.
          </p>
        </div>
      </section>
    </main>
  );
}
